/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable camelcase */
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
// import { BrowserView, MobileView } from "react-device-detect";
import { BiInfoCircle, BiFile } from "react-icons/bi";
import { GiFamilyTree } from "react-icons/gi";
import { Amplify } from "aws-amplify";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import aws_exports from "./aws-exports";
import Header from "./components/Header";
import About from "./components/About";
import Documents from "./components/Documents";
// import Resources from "./components/Resources";
import FamilyTree from "./components/FamilyTree";
import FamilyTreeData from "./components/FamilyTreeData";
import FamilyTreeTest from "./components/FamilyTreeTest";
import Recipes from "./components/Recipes";
// import Gallery from "./components/Gallery";
import Profile from "./components/Profile";
import Settings from "./components/Settings";
import Wip from "./components/Wip";
import "react-dropzone-uploader/dist/styles.css";
// eslint-disable-next-line import/no-unresolved
import "@aws-amplify/ui-react/styles.css";

Amplify.configure(aws_exports);
// Amplify.Logger.LOG_LEVEL = "DEBUG";

const bodyStyle = {
    // minWidth: "1000px",
};

const headerStyle = {
    display: "inline-flex",
    width: "100%",
    boxShadow: "0px 0px 9px 3px rgba(41,41,41,.25)",
    height: "2.25em",
    minWidth: "1075px",
};

const navStyle = {
    // margin: "0.05em",
    marginLeft: "0.1em",
    width: "40%",
    float: "left",
};

const buttonStyle = {
    margin: "0.2em",
    alignItems: "center",
    display: "flex",
    // fontSize: "0.9em",
    // padding: "0.45em",
    // paddingTop: "0.2em",
    // paddingBottom: "0.2em",
};

const buttonIconStyle = {
    marginRight: "0.2em",
};

// const footerStyle = {
//     position: "absolute",
//     textAlign: "center",
//     // width: "100vw",
//     boxShadow: "0px 0px 9px 3px rgba(41,41,41,.25)",
//     margin: "0 30% 1em 30%",
//     background: "#ff9999",
//     left: 0,
//     bottom: 0,
//     right: 0,
//     borderRadius: "2em",
//     zIndex: 999,
// };

const checkActive = (match, location) => {
    if (!location) return false;
    const { pathname } = location;
    return pathname === "/";
};

function App({ signOut, user }) {
    // const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
    const [nightMode, setNightMode] = useState(() => {
        const saved = localStorage.getItem("nightMode");
        return saved !== null ? JSON.parse(saved) : false;
    });

    useEffect(() => {
        localStorage.setItem("nightMode", JSON.stringify(nightMode));
        if (nightMode) {
            document.body.classList.add("night-mode");
        } else {
            document.body.classList.remove("night-mode");
        }
    }, [nightMode]);

    let chosenTester = false;
    if (user.attributes.email === "david.fedorovsky@gmail.com") chosenTester = true;
    return (
        <BrowserRouter>
            <header style={headerStyle}>
                <ButtonToolbar style={navStyle}>
                    <LinkContainer isActive={checkActive} to="/" style={buttonStyle}>
                        <Button variant="outline-primary" size="sm">
                            <GiFamilyTree style={buttonIconStyle} /> Family Tree
                        </Button>
                    </LinkContainer>
                    <LinkContainer to="/family-tree-data" style={buttonStyle}>
                        <Button variant="outline-primary" size="sm">
                            <GiFamilyTree style={buttonIconStyle} /> Family Tree Data
                        </Button>
                    </LinkContainer>
                    <LinkContainer to="/documents" style={buttonStyle}>
                        <Button variant="outline-primary" size="sm">
                            <BiFile style={buttonIconStyle} /> Documents
                        </Button>
                    </LinkContainer>
                    {/* <LinkContainer to="/family-tree-test" style={buttonStyle}>
                        <Button variant="outline-info" size="sm">
                            <GiFamilyTree style={buttonIconStyle} /> Family Tree Test
                        </Button>
                    </LinkContainer> */}
                    {/* <LinkContainer to="/gallery" style={buttonStyle}>
                        <Button variant="outline-secondary">
                            <BiPhotoAlbum style={buttonIconStyle} /> Gallery
                        </Button>
                    </LinkContainer>
                    <LinkContainer to="/recipes" style={buttonStyle}>
                        <Button variant="outline-secondary">
                            <GiKnifeFork style={buttonIconStyle} /> Recipes
                        </Button>
                    </LinkContainer> */}
                    {/* <LinkContainer to="/resources" style={buttonStyle}>
                        <Button variant="outline-primary">
                            <BiInfoCircle style={buttonIconStyle} /> Resources
                        </Button>
                    </LinkContainer> */}
                    <LinkContainer to="/about" style={buttonStyle}>
                        <Button variant="outline-primary" size="sm">
                            <BiInfoCircle style={buttonIconStyle} /> About
                        </Button>
                    </LinkContainer>
                </ButtonToolbar>
                <Header signOut={signOut} user={user} />
            </header>
            <div style={bodyStyle}>
                <Routes>
                    <Route path="/" Component={FamilyTree} />
                    <Route path="/documents" Component={Documents} />
                    <Route path="/family-tree-data" Component={FamilyTreeData} />
                    <Route path="/family-tree-test" Component={FamilyTreeTest} />
                    <Route path="/recipes" element={chosenTester ? Recipes() : <Wip />} />
                    <Route path="/gallery" Component={Wip} />
                    <Route path="/about" exact element={About({ user })} />
                    <Route path="/profile" element={Profile({ user })} />
                    <Route path="/settings" element={Settings({ nightMode, setNightMode })} />
                </Routes>
                {/* <MobileView>
                    <h1>This is rendered only on mobile</h1>
                </MobileView> */}
                {/* <BrowserView>
                    <div style={footerStyle}>
                        <CiWarning /> Mobile view is not optimized, please use a computer/laptop/tablet
                    </div>
                </BrowserView> */}
            </div>
        </BrowserRouter>
    );
}

export default withAuthenticator(App);
